import { useEffect } from "react";
import { useField } from "formik";
import { SelectField, useCountries } from "melco-shared-logic";
import { SizeType } from "../../types/layout";

type RegisterUserCountrySelectProps = {
  name?: string;
  disabled?: boolean;
  label?: string;
  size?: SizeType;
};

const RegisterUserCountrySelect: React.FC<RegisterUserCountrySelectProps> = ({
  name,
  disabled,
  label,
  size,
}) => {
  //const { t } = useTranslation();
  const { countries, isLoading } = useCountries();
  const [field, , helpers] = useField("country_code");

  useEffect(() => {
    if (isLoading) {
      return;
    }

    // select US by default
    // if (isEmpty(field.value)) {
    // helpers.setValue("US");
    // }
  }, [isLoading, field, helpers]);

  return (
    <SelectField
      name={name ? name : "country_code"}
      label={label}
      size={size}
      //  placeholder={t("global.form.label.profile.country_code")}
      options={countries.map((c) => {
        return {
          label: c.name,
          value: c.code,
        };
      })}
      loading={isLoading}
      showSearch
      optionFilterProp="label"
      disabled={disabled || isLoading}
    />
  );
};

export default RegisterUserCountrySelect;
